import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import PublisherSetPassword from "@/pages/publisher/PublisherSetPassword";

export const Route = createFileRoute("/publisher/set-password")({
  head: () => pageHead("Publisher \u2014 Set Password \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: PublisherSetPassword,
});
